import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import ImageGallery from 'react-image-gallery';
import './styles.css';

const commonTitle = `vacation packages, budget travel, travel agency, trip, Galle, Adams peak, Ambuluwawa, Ambuluwawa, Ambuluwawa, Ambuluwawa, Anuradhapura, Anuradhapura, Arugambe, Bentota, ceylon, Colombo, Colombo, Colombo, Dambulla, Dambulla, Dambulla, Dambulla, Dambulla, Dambulla, Ella, Ella, Ella, Ella, Explore the northern Sri Lanka, Exploring the scenic beauty of Central Highlands, Galle, Galle, Galle, Hikkaduwa, Horton Plains, Horton plains, Jaffna, Kalpitiya, Kandy, Kandy, Kandy, Kandy, Kandy, leisure, Lion Rock, Lion rock, Lion rock, Lion rock, Lion Rock, Lion Rock, Little England, manel, manel travels, maneltravels, Mihintale, Mirissa, Mirissa, Mirissa, N' Eliya, N' Eliya, N'Eliya, Negombo, Pasikuda, Pasikuddah, Pinnawala, Pinnawala, Pinnawala, Pinnawala, Pinnawala, Pollonnaruwa, Polonnaruwa, Relaxing on the golden beaches, serendib, sri lanka, travel, travels, Trincomalee, trip, Uda walawe, Unawatuna, vacation, world's end, Yala, Yala safari,maneltravels.lk`;
const commonAlt =
  'Manel Travels and Leisure Professional. travel & leisure solutions provider with sense of homely nature. We always aiming at keeping you delighted by providing travel & leisure solutions to match your wallet with warrantied value delivery. We do undertake day excursions, multi day family holiday tours, work related local travel solutions with our expertise to make the occasion a memorable experience to you whilst adding more value to it. Your safety is our utmost concern right through out the period concerned.';

const images = [
  {
    original: '/images/gallery/pic_16.webp',
    thumbnail: '/images/gallery/pic_16.webp',
  },
  {
    original: '/images/gallery/pic_17.webp',
    thumbnail: '/images/gallery/pic_17.webp',
  },
  {
    original: '/images/gallery/pic_18.webp',
    thumbnail: '/images/gallery/pic_18.webp',
  },
  {
    original: '/images/gallery/pic_19.webp',
    thumbnail: '/images/gallery/pic_19.webp',
  },
  {
    original: '/images/gallery/pic_20.webp',
    thumbnail: '/images/gallery/pic_20.webp',
  },
  {
    original: '/images/gallery/pic_21.webp',
    thumbnail: '/images/gallery/pic_21.webp',
  },
  {
    original: '/images/gallery/pic_22.webp',
    thumbnail: '/images/gallery/pic_22.webp',
  },
  {
    original: '/images/gallery/pic_23.webp',
    thumbnail: '/images/gallery/pic_23.webp',
  },
  {
    original: '/images/gallery/pic_24.webp',
    thumbnail: '/images/gallery/pic_24.webp',
  },
  {
    original: '/images/gallery/pic_25.webp',
    thumbnail: '/images/gallery/pic_25.webp',
  },
  {
    original: '/images/gallery/pic_26.webp',
    thumbnail: '/images/gallery/pic_26.webp',
  },
  {
    original: '/images/gallery/pic_27.webp',
    thumbnail: '/images/gallery/pic_27.webp',
  },
  {
    original: '/images/gallery/pic_28.webp',
    thumbnail: '/images/gallery/pic_28.webp',
  },
  {
    original: '/images/gallery/pic_29.webp',
    thumbnail: '/images/gallery/pic_29.webp',
  },
  {
    original: '/images/gallery/pic_30.webp',
    thumbnail: '/images/gallery/pic_30.webp',
  },
  {
    original: '/images/gallery/pic_4.webp',
    thumbnail: '/images/gallery/pic_4.webp',
  },
  {
    original: '/images/gallery/pic_7.webp',
    thumbnail: '/images/gallery/pic_7.webp',
  },
  {
    original: '/images/gallery/pic_6.webp',
    thumbnail: '/images/gallery/pic_6.webp',
  },
  {
    original: '/images/gallery/pic_9.webp',
    thumbnail: '/images/gallery/pic_9.webp',
  },
  {
    original: '/images/gallery/pic_12.webp',
    thumbnail: '/images/gallery/pic_12.webp',
  },
  {
    original: '/images/gallery/pic_14.webp',
    thumbnail: '/images/gallery/pic_14.webp',
  },
  {
    original: '/images/gallery/pic_13.webp',
    thumbnail: '/images/gallery/pic_13.webp',
  },
  {
    original: '/images/gallery/pic_15.webp',
    thumbnail: '/images/gallery/pic_15.webp',
  },
  {
    original: '/images/gallery/pic_2.webp',
    thumbnail: '/images/gallery/pic_2.webp',
  },
  {
    original: '/images/gallery/pic_3.webp',
    thumbnail: '/images/gallery/pic_3.webp',
  },
  {
    original: '/images/gallery/pic_1.webp',
    thumbnail: '/images/gallery/pic_1.webp',
  },
  {
    original: '/images/gallery/pic_5.webp',
    thumbnail: '/images/gallery/pic_5.webp',
  },
  {
    original: '/images/gallery/pic_8.webp',
    thumbnail: '/images/gallery/pic_8.webp',
  },
  {
    original: '/images/gallery/pic_10.webp',
    thumbnail: '/images/gallery/pic_10.webp',
  },
  {
    original: '/images/gallery/pic_11.webp',
    thumbnail: '/images/gallery/pic_11.webp',
  },
];

const GalleryPanel: React.FC = () => (
  <Container
    maxWidth="xl"
    sx={{ marginTop: 5, marginBottom: 10 }}
    className="gallery_container"
  >
    <Container maxWidth="lg">
      <Typography
        gutterBottom
        variant="h3"
        sx={{ marginBottom: 5 }}
        className="title"
      >
        Gallery
      </Typography>
      <Box sx={{ width: '100%' }}>
        <ImageGallery
          items={images.map((item) => ({
            ...item,
            originalAlt: commonAlt,
            thumbnailAlt: commonAlt,
            originalTitle: commonTitle,
            thumbnailTitle: commonTitle,
          }))}
        />
      </Box>
    </Container>
  </Container>
);

export default GalleryPanel;
